var map = {
	".": 48,
	"./": 48,
	"./deletefile": 74,
	"./deletefile.js": 74,
	"./downloadfile": 73,
	"./downloadfile.js": 73,
	"./features": 38,
	"./features.js": 38,
	"./index": 48,
	"./index.js": 48,
	"./uploadfile": 71,
	"./uploadfile.js": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;